import { Component } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error untyped JS module
import formatName from '../utils/formatName';
// @ts-expect-error untyped JS module
import formatFriendlyName from '../utils/formatFriendlyName';
import TitleTypes from '../constants/TitleTypes';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedName extends Component {
  render() {
    const {
      email,
      familyName,
      givenName,
      isFriendly,
      name,
      options,
      titleType
    } = this.props;
    const formattedName = isFriendly ? formatFriendlyName({
      givenName,
      familyName,
      email
    }, options) : formatName({
      firstName: givenName,
      lastName: familyName,
      email,
      name,
      titleType
    }, options);
    return /*#__PURE__*/_jsx("span", {
      children: formattedName
    });
  }
}
FormattedName.displayName = 'FormattedName';
FormattedName.contextType = I18nHMRContext;
FormattedName.propTypes = {
  email: PropTypes.string,
  familyName: PropTypes.string,
  givenName: PropTypes.string,
  isFriendly: PropTypes.bool,
  name: PropTypes.string,
  options: PropTypes.object,
  titleType: PropTypes.oneOf(Object.values(TitleTypes))
};
FormattedName.defaultProps = {
  isFriendly: false
};